"use strict";

import applications from "@/services/applications";
import applicationTypes from "@/services/applicationTypes";

export default (ctx, inject) => {
  inject("applications", applications(ctx.$axios, ctx.store));
  inject("applicationTypes", applicationTypes(ctx.$axios, ctx.store));
};
